import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { DeviationConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { AllocationDeviationService } from './api/allocationDeviation.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class DeviationApiModule {
    public static forRoot(configurationFactory: () => DeviationConfiguration): ModuleWithProviders<DeviationApiModule> {
        return {
            ngModule: DeviationApiModule,
            providers: [ { provide: DeviationConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: DeviationApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('DeviationApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
